import moment from 'moment';

export const dateOshaValidation = () => {
  const today = moment();
  const year = today.year();
  const start = moment({ year, month: 0, day: 2 }); // January is 0
  const end = moment({ year, month: 2, day: 2 }); // March is 2
  return today.isSameOrAfter(start) && today.isSameOrBefore(end);
};
